import { Panel } from '@app/components/base/content-structure/Panel';
import { defineMessage, FormattedMessage } from 'react-intl';
import { useTranscriptionPanelViewportMaxHeight } from '../hooks/useTranscriptionPanelViewportMaxHeight';
import { TranscriptionToolbar } from './TranscriptionToolbar';
import { TranscriptionView } from './TranscriptionView';

const transcriptionPanelTitleMessage = defineMessage({
  id: 'fragments.transcription.panelTitle',
  defaultMessage: 'Transcripción',
});

/**
 * Transcription panel for a fragment: waits for media completion, then renders the v2 transcript UI.
 * Toolbar actions sit in the panel header; the search field appears below when toggled on.
 */
export function TranscriptionPanel() {
  const transcriptionPanelMaxHeight = useTranscriptionPanelViewportMaxHeight();

  return (
    <Panel
      title={<FormattedMessage {...transcriptionPanelTitleMessage} />}
      actions={<TranscriptionToolbar />}
      sx={{
        height: '100%',
        maxHeight: transcriptionPanelMaxHeight,
      }}
    >
      <TranscriptionView />
    </Panel>
  );
}
